import { authServerInstance } from "../axiosInstance";

export const getFormVisibilityMap = async (data) => {
  try {
    const response = await authServerInstance.post("form-visibility", data);
    console.log("response.data",response.data)
    return response.data;
  } catch (e) {
    console.error(e);
  }
};
